import type {
  AvailabilityState,
  CrowdLevel,
  FeatureKey,
  PublicAccessType,
  QueueBand,
} from "./types";

export const stateMeta: Record<
  AvailabilityState,
  { label: string; shortLabel: string; symbol: string }
> = {
  available_confirmed: {
    label: "利用確認済み",
    shortLabel: "確認済み",
    symbol: "✓",
  },
  available_likely: {
    label: "利用見込み",
    shortLabel: "見込み",
    symbol: "○",
  },
  limited: {
    label: "混雑・制限あり",
    shortLabel: "混雑・制限",
    symbol: "◷",
  },
  likely_unavailable: {
    label: "利用困難見込み",
    shortLabel: "利用困難",
    symbol: "／",
  },
  unavailable_confirmed: {
    label: "利用不可確認済み",
    shortLabel: "利用不可",
    symbol: "×",
  },
  unknown: {
    label: "状況不明",
    shortLabel: "不明",
    symbol: "?",
  },
};

export const featureMeta: Record<FeatureKey, string> = {
  wheelchair: "車いす",
  ostomate: "オストメイト",
  baby_changing: "おむつ交換",
  child_seat: "乳幼児用椅子",
  gender_neutral: "男女共用",
};

export const accessMeta: Record<PublicAccessType, string> = {
  always_public: "常時一般利用",
  business_hours_only: "開館時間内",
  facility_users_only: "施設利用者向け",
  event_only: "催事・入館条件あり",
  unknown: "一般利用条件は要確認",
};

export const crowdMeta: Record<CrowdLevel, string> = {
  normal: "通常",
  busy: "混雑見込み",
  very_busy: "非常に混雑する見込み",
  unknown: "混雑不明",
};

export const queueBandMeta: Record<QueueBand, string> = {
  under_5_min: "5分未満",
  "5_to_15_min": "5〜15分",
  over_15_min: "15分以上",
};

export function formatDateTime(value: string | Date, withDate = true) {
  const date = value instanceof Date ? value : new Date(value);
  return new Intl.DateTimeFormat("ja-JP", {
    timeZone: "Asia/Tokyo",
    month: withDate ? "numeric" : undefined,
    day: withDate ? "numeric" : undefined,
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function formatDistance(meters: number) {
  if (meters < 1_000) return `${meters}m`;
  return `${(meters / 1_000).toFixed(1)}km`;
}
